import { useGlobalStore } from '@highlight/ipc/react'

export const useStartNewChatTimeout = () => {
  return useGlobalStore<number>('settings', 'startNewChatTimeout', 15)
}
